<template>
  <div>
    <div class="pa-2 cyan">
      <span class="text-subtitle-1 font-weight-bold white--text"
        >生成AI共通の設定</span
      >
    </div>
    <v-card tile elevation="0" class="item-card pa-2">
      <v-card-text class="pa-0">
        <div class="pb-2 mb-2">
          <span class=""
            >ここで指定した内容によってコメントの雰囲気が変わります。精度の高い文章を生成したい場合は、必ず設定してください。</span
          >
        </div>
        <v-container fluid>
          <v-row>
            <v-col cols="12" sm="2"
              ><span class="font-weight-bold">店舗全体の設定</span></v-col
            >
            <v-col cols="12" sm="10">
              <genaiSettingItem
                ref="refShopSetting"
                :key_start="'genai__shop_setting'"
                :items="items"
                :shop_prop="shopProp"
              ></genaiSettingItem>
            </v-col>
          </v-row>
          <v-divider class="mt-4 mb-8"></v-divider>

          <v-row class="mb-4">
            <v-col cols="12" sm="2"
              ><span class="font-weight-bold">お店コメント設定</span>
            </v-col>
            <v-col cols="12" sm="10">
              <v-row>
                <v-col cols="12" class="mb-2">
                  <h4 class="mb-2">かんたん設定</h4>
                  お店コメントの雰囲気を選択してください。カスタム設定を選択すると口調や文章のトーンを自由に指定できます。
                  <v-radio-group
                    v-model="shopCommentPresetValue"
                    class="mt-2"
                    hide-details
                  >
                    <v-radio
                      v-for="preset in shopCommentPresets"
                      class="mt-2"
                      :key="preset.type_id"
                      :value="preset.type_id"
                    >
                      <template v-slot:label>
                        <span class="d-flex flex-column">
                          <span class="">{{ preset.type_name }}</span>
                          <span class="mini">
                            {{ preset.type_description }}
                          </span>
                        </span>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-divider class="my-4 mb-8"></v-divider>
              <v-row>
                <v-col cols="12" class="mb-2">
                  <h4 class="mb-2">カスタム設定</h4>
                  お店コメントで生成する文章の目標とする文字数を指定してください。未指定の場合、{{
                    setting.genai_shop_comment_char_count
                  }}文字となります。<br /><span class="red--text"
                    >※指定した文字数に収まるように指示しますが、結果にばらつきがあります。</span
                  >
                </v-col>
              </v-row>
              <genaiSettingItem
                ref="refShopComment"
                :key_start="'genai__shop_comment'"
                :items="items"
                :shop_prop="shopProp"
                :disabled="shopCommentPresetValue !== 9999"
              ></genaiSettingItem>
              <v-row class="mt-4">
                <v-col cols="12" class="mb-2">
                  セラピスト情報に登録してあるお店コメント（テキスト版のみ）を手本にしてAIに文章を作らせたい場合、お手本とするセラピストを選択してください。<br />
                  文章の雰囲気や改行スタイルなどが手本に近いものになります。最大{{
                    max_cast_select
                  }}名まで選択可能です。
                </v-col>
                <v-col cols="12">
                  <v-row class="mb-2">
                    <v-col cols="12" sm="6"></v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field
                        v-model="castSearch"
                        append-icon="mdi-magnify"
                        label="（セラピスト名検索）"
                        single-line
                        hide-details
                        clearable
                        dense
                        class="mb-2"
                        :disabled="shopCommentPresetValue !== 9999"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row class="d-flex flex-wrap cast-list-box">
                    <v-col
                      v-for="cast in filteredCasts"
                      :key="cast.id"
                      cols="6"
                      sm="4"
                      md="3"
                      class="d-flex align-start pa-2"
                    >
                      <div
                        class="cast-select-box"
                        :class="{
                          selected: castSelected.includes(cast.id),
                          'v-disabled': shopCommentPresetValue !== 0,
                        }"
                        @click="
                          shopCommentPresetValue === 9999 && selectCast(cast.id)
                        "
                        :style="
                          shopCommentPresetValue !== 9999
                            ? 'pointer-events: none; opacity: 0.5;'
                            : ''
                        "
                      >
                        <v-avatar class="ma-1 mr-3">
                          <v-img
                            v-if="cast.image"
                            :src="setting.cdn + cast.image"
                          />
                          <v-img v-else src="@/assets/images/no_image.jpg" />
                        </v-avatar>
                        <span class="text-truncate">{{ cast.name }}</span>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <!-- <v-divider class="mt-4 mb-8"></v-divider>

          <v-row class="mb-4">
            <v-col cols="12" sm="2"
              ><span class="font-weight-bold">セラピストコメント設定</span>
            </v-col>
            <v-col cols="12" sm="10">
              <v-row>
                <v-col cols="12" class="mb-2">
                  セラピストコメントで生成する文章の目標とする文字数を指定してください。未指定の場合、{{
                    setting.genai_cast_comment_char_count
                  }}文字となります。<br /><span class="red--text"
                    >※指定した文字数以内で作成するように指示しますが、必ずしも指定文字数内に収まるとは限りません。</span
                  >
                </v-col>
              </v-row>
              <genaiSettingItem
                ref="refCastComment"
                :key_start="'genai__cast_comment'"
                :items="items"
                :shop_prop="shopProp"
              ></genaiSettingItem>
            </v-col>
          </v-row> -->
        </v-container>
      </v-card-text>
    </v-card>
    <v-container fluid>
      <v-row justify="start">
        <v-col cols="6" sm="3">
          <general-button btn_type="info" btn_block @click-event="onSubmit"
            ><template v-slot:icon
              ><v-icon left>mdi-content-save</v-icon></template
            >保存</general-button
          >
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import {
  set,
  ref,
  reactive,
  toRefs,
  defineComponent,
  computed,
  onMounted,
} from "@vue/composition-api";
import { repositoryFactory } from "@/repository/repositoryFactory";
import store from "@/store/index.js";
import setting from "@/common/setting.js";
import retryRequest from "@/common/retryRequest";
import utilFunc from "@/common/utilFunc.js";
import genaiSettingItem from "./genaiSettingItem.vue";

export default defineComponent({
  components: {
    genaiSettingItem,
  },
  setup(props, ctx) {
    const CastsRepository = repositoryFactory.get("casts");
    const ShopPropsRepository = repositoryFactory.get("shopProps");
    const AiRepository = repositoryFactory.get("ai");

    const refShopSetting = ref(false);
    const refShopComment = ref(false);
    const refCastComment = ref(false);

    const state = reactive({
      casts: [],
      castSelected: [],
      shopProp: {},
      castSearch: "",
      shopCommentPresets: [],
      shopCommentPresetValue: 1,
      castCommentPresets: [],
      castCommentPresetValue: 1,
    });

    // 生成AIで使用する店舗設定項目
    const items = {
      "genai__shop_setting__usp": {
        type: "text",
        text: "お店の特徴・強み",
        rules: "max:100",
        counter: "100",
        placeholder: "例：高い技術力、丁寧な接客、豊富なメニュー",
        hint: "店舗の強みや特徴を簡潔に記載してください。",
      },
      "genai__shop_setting__atmosphere": {
        type: "text",
        text: "お店の雰囲気",
        rules: "max:100",
        counter: "100",
        placeholder: "例：ラグジュアリー、高級店、カジュアル、アットホーム",
        hint: "お店の雰囲気を記載してください。",
      },
      "genai__shop_setting__target_audience": {
        type: "text",
        text: "ターゲット層・顧客層",
        rules: "max:100",
        counter: "100",
        placeholder: "例：20代から30代の男性、ビジネスマン、富裕層向け",
        hint: "主な顧客層やターゲット層を明確にしてください。",
      },
      "genai__shop_comment__char_count": {
        type: "number",
        text: "目標文字数",
        rules: "numeric|min_value:100|max_value:1500",
        counter: "",
        placeholder: "300",
        hint: "100文字〜1500文字まで指定可能",
      },
      "genai__shop_comment__brand_voice": {
        type: "text",
        text: "口調・文体・文章のトーン",
        rules: "max:100",
        counter: "100",
        placeholder:
          "例：丁寧で親しみやすい、プロフェッショナルで信頼感がある口調、絵文字を多用する",
        hint: "文章のトーンやスタイルを指定してください。",
      },
      "genai__shop_comment__examples": {
        type: "cast",
        text: "",
        rules: "",
        counter: "",
        placeholder: "",
        hint: "",
      },
      // "genai__cast_comment__char_count": {
      //   type: "number",
      //   text: "目標文字数",
      //   rules: "numeric|min_value:100|max_value:1500",
      //   counter: "",
      //   placeholder: "300",
      //   hint: "100文字〜1500文字まで指定可能",
      // },
    };

    const max_cast_select = 5;

    onMounted(async () => {
      store.dispatch("loadingIcon/showIcon");

      const currentShop = store.getters["shops/currentShop"];
      // console.log(currentShop);

      // かんたん設定のプリセットを読み込み
      const preset = await retryRequest(AiRepository.preset_list, {});
      state.shopCommentPresets.splice(0);
      state.castCommentPresets.splice(0);
      if (preset.data) {
        if (preset.data.categories.length > 0) {
          for (let i = 0; i < preset.data.categories.length; i++) {
            const category = preset.data.categories[i];
            if (category.category_name === "shop_comment") {
              // お店コメント用プリセット
              for (let j = 0; j < category.presets.length; j++) {
                state.shopCommentPresets.push(category.presets[j]);
              }
            } else if (category.key === "genai__cast_comment__preset") {
              // セラピストコメント用プリセット
              for (let j = 0; j < category.presets.length; j++) {
                state.castCommentPresets.push(category.presets[j]);
              }
            }
          }
        }
      }
      state.shopCommentPresets.push({
        type_id: 9999,
        type_name: "カスタム設定",
        type_description: "下記の「カスタム設定」にて値を指定してください。",
      });
      state.castCommentPresets.push({
        type_id: 9999,
        type_name: "カスタム設定",
        type_description: "下記の「カスタム設定」にて値を指定してください。",
      });

      // console.log("state.shopCommentPresets", state.shopCommentPresets);

      // システム内の登録セラピストをstoreから取得する
      state.casts.splice(0);
      let params = new URLSearchParams();
      params.append("shop_id", currentShop.id);
      const response = await retryRequest(CastsRepository.list, params);
      if (response.data) {
        Object.keys(response.data).forEach(function (key) {
          state.casts.push(response.data[key]);
        });
      }

      // shopPropにキーを設定
      for (let key in items) {
        set(state.shopProp, key, null);
      }
      const shopProps = currentShop.data.prop;
      for (let index in shopProps) {
        if (shopProps[index].key === "genai__shop_comment__examples") {
          // 選択済みセラピストをセット
          state.castSelected = JSON.parse(shopProps[index].value);
        } else if (shopProps[index].key === "genai__shop_comment__preset") {
          // お店コメントのかんたん設定プリセット値をセット
          state.shopCommentPresetValue = parseInt(shopProps[index].value);
          // } else if (shopProps[index].key === "genai__cast_comment__preset") {
          //   // セラピストコメントのかんたん設定プリセット値をセット
          //   state.castCommentPresetValue = parseInt(shopProps[index].value
        } else {
          set(state.shopProp, shopProps[index].key, shopProps[index].value);
        }
      }
      // state.castSelectedの中に、state.castsに存在しないIDがあれば削除する
      state.castSelected = state.castSelected.filter((id) =>
        state.casts.some((cast) => cast.id === id)
      );

      // console.log("state.shopProp", state.shopProp);

      await store.dispatch("loadingIcon/hideIcon");
    });

    const selectCast = (id) => {
      if (!state.castSelected.includes(id)) {
        // 5名未満なら選択可能
        if (state.castSelected.length < max_cast_select) {
          state.castSelected.push(id);
        }
      } else {
        // すでに選択済みなら解除
        state.castSelected = state.castSelected.filter((cid) => cid !== id);
      }
    };

    const filteredCasts = computed(() => {
      if (!state.castSearch) return state.casts;
      return state.casts.filter(
        (cast) =>
          cast.name &&
          cast.name.toLowerCase().includes(state.castSearch.toLowerCase())
      );
    });

    const onSubmit = async () => {
      // 店舗設定のチェック
      const isValidSetting = await refShopSetting.value.errorCheck();
      if (!isValidSetting) {
        return;
      }
      // お店コメント設定のチェック
      const isValidShopComment = await refShopComment.value.errorCheck();
      if (!isValidShopComment) {
        return;
      }
      // // セラピストコメント設定のチェック
      // const isValidCastComment = await refCastComment.value.errorCheck();
      // if (!isValidCastComment) {
      //   return;
      // }

      // 確認
      if (!window.confirm("店舗設定を保存します。よろしいですか？")) {
        return;
      }

      store.dispatch("loadingIcon/showIcon"); // ローディング表示

      // 選択されたセラピストIDをカンマ区切りで保存
      state.shopProp["genai__shop_comment__examples"] = JSON.stringify(
        state.castSelected
      );

      const shopId = store.getters["shops/currentShop"].id;
      const params = [];
      for (let key in items) {
        // 店舗設定保存
        const propKey = key;
        const propValue = state.shopProp[key];
        const prop = {
          shop_id: shopId,
          key: propKey,
          value: propValue || "",
        };
        params.push(prop);
      }
      // かんたん設定のプリセット値も保存
      params.push({
        shop_id: shopId,
        key: "genai__shop_comment__preset",
        value: state.shopCommentPresetValue,
      });
      // params.push({
      //   shop_id: shopId,
      //   key: "genai__cast_comment__preset",
      //   value: state.castCommentPresetValue,
      // });

      // DBの更新
      await ShopPropsRepository.save_all(params)
        .then((response) => {
          if (response.data) {
            // データ追加OK save_allを使った場合、storeの全propを更新しておく
            Object.keys(response.data).forEach(function (key) {
              store.dispatch("shops/setProp", {
                "id": response.data[key].id,
                "key": response.data[key].key,
                "value": response.data[key].value,
              });
            });
          }
        })
        .catch((error) => {
          throw "ERROR:ShopPropsRepository.save_all (" + error + ")";
        });

      store.dispatch("loadingIcon/hideIcon"); // ローディング非表示

      alert("AI設定を保存しました。");

      // ctx.emit("move-to-ai-setting", 0);
    };

    return {
      items,
      refShopSetting,
      refShopComment,
      refCastComment,
      setting,
      max_cast_select,
      ...toRefs(state),
      selectCast,
      onSubmit,
      filteredCasts,
    };
  },
});
</script>

<style scoped>
.cast-select-box {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 4px;
  border-radius: 8px;
  cursor: pointer;
  background-color: #f5f5f5;
  border: 2px solid white;
}
.cast-select-box.selected {
  background-color: #1976d2;
  color: white;
}
.cast-select-box:hover {
  border: 2px solid #c5c5c5;
}
.cast-list-box {
  max-height: 60vh;
  overflow-y: auto;
}
</style>
